var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 */
export default class RadioGroup extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }
    render() {
        const _a = this.props, { prefixCls, className, children: cld, disabled, readOnly } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "disabled", "readOnly"]);
        const children = this.handleCloneChildren(cld);
        return (<div className={cls(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-readOnly`]: readOnly
        })} {...resetProps}>{children}</div>);
    }
    get value() {
        return this.state.value;
    }
    handleCloneChildren(children) {
        const { disabled, readOnly } = this.props;
        return Array.isArray(children)
            ? children.map((radio) => this.handleCloneChildren(radio))
            : React.cloneElement(children, {
                key: children.key || `__${+new Date() + Math.random()}__`,
                checked: this.state.value === children.props.value,
                disabled: disabled || children.props.disabled,
                readOnly: readOnly || children.props.readOnly,
                onClick: () => children.props.disabled || children.props.readOnly || this.setState({ value: children.props.value })
            });
    }
}
RadioGroup.defaultProps = {
    prefixCls: 'x-radio-group'
};
